import React from 'react';
import DashboardHeader from './DashboardHeader';
import Footer from './Footer';

const DashboardLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'var(--ludo-canvas)' }}>
      <DashboardHeader />
      <main className="max-w-[1400px] mx-auto p-6 flex-1 w-full">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default DashboardLayout;
